import type { AppFlowsContainer } from '#flows.js';
import type { FirestoreContainer } from './FirestoreContainer.js';

import { createContainer } from '@elara/core/di';

import { createClientShortlistGroupModel } from '#models/ShortlistGroupModel.js';
import { createClientShortlistItemModel } from '#models/ShortlistItemModel.js';

export function createShortlistContainer(flows: AppFlowsContainer, firestore: FirestoreContainer) {
  const $shortlist = createContainer('shortlist')
    .providedLazy('ClientShortlistItem', () => createClientShortlistItemModel(firestore))
    .providedLazy('ClientShortlistGroup', () => createClientShortlistGroupModel(firestore))
    .provided('addShortlistItem', flows.addShortlistItem)
    .provided('updateShortlistItem', flows.updateShortlistItem)
    .provided('removeShortlistItem', flows.removeShortlistItem)
    .provided('reorderItems', flows.batchReorderShortlistItems)
    .provided('createShortlistGroup', flows.createShortlistGroup)
    .provided('updateShortlistGroup', flows.updateShortlistGroup)
    .provided('deleteShortlistGroup', flows.deleteShortlistGroup)
    .provided('reorderGroups', flows.batchReorderShortlistGroups);

  return $shortlist;
}

export type $ShortlistContainer = ReturnType<typeof createShortlistContainer>;
export type ShortlistContainer = $ShortlistContainer['use'];

